module.exports = __webpack_public_path__ + "static/website-builder-17c973f891ec35c457b8b0c750d8fc34.jpg";